import React from 'react';
import { AssignToController } from './useAssignToController';

//  Initialize with empty.  The Provider will fill this in once it gets the controller assembled
export const AssignToControllerContext = React.createContext<AssignToController>({} as AssignToController);

//  This exposes the controller to every child that wants to use it :-)
export const useAssignToProvider = () => React.useContext(AssignToControllerContext);
